if (!customElements.get('pdp-calculator')) {
  class PdpCalculator extends HTMLElement {
    constructor() {
      super();
      this.handleInput = this.handleInput.bind(this);
      this.handleOverageChange = this.handleOverageChange.bind(this);
      this.runCalculator = this.runCalculator.bind(this);
    }

    connectedCallback() {
      this.quantitySelector = document.querySelector(
        '[x-data="QuantityStepper"] [x-ref="quantityInput"]'
      );
      this.minBoxQty = parseInt(this.dataset.minboxqty, 10);
      this.boxSqFt = parseInt(this.dataset.boxsqft, 10);
      this.minQuantity = this.minBoxQty * this.boxSqFt;
      this.maxSize = this.boxSqFt;

      this.sqftInput = this.querySelector('.sqft_needed');
      this.overageSelect = this.querySelector('select');
      this.totalBoxesInput = this.querySelector('.total_boxes');

      if (!this.sqftInput || !this.overageSelect || !this.totalBoxesInput) {
        return;
      }

      if (!this.minQuantity || !this.maxSize) {
        return;
      }

      this.sqftInput.addEventListener('input', this.handleInput);
      this.overageSelect.addEventListener('change', this.handleOverageChange);
    }

    disconnectedCallback() {
      if (this.sqftInput) {
        this.sqftInput.removeEventListener('input', this.handleInput);
      }
      if (this.overageSelect) {
        this.overageSelect.removeEventListener('change', this.handleOverageChange);
      }
    }

    handleInput(event) {
      event.preventDefault();
      event.stopPropagation();
      this.runCalculator();
    }

    handleOverageChange() {
      this.runCalculator();
    }

    runCalculator() {
      let inputValue = parseInt(this.sqftInput.value, 10);
      const overage = parseFloat(this.overageSelect.value);
      if (overage > 0 && !Number.isNaN(inputValue)) {
        inputValue += Math.ceil(inputValue * overage);
      }

      if (!this.totalBoxesInput) {
        return;
      }

      if (inputValue > 0 && inputValue <= this.minQuantity) {
        const totalBoxes = Math.ceil(this.minQuantity / this.maxSize);
        this.totalBoxesInput.value = totalBoxes;
        if (this.quantitySelector) {
          this.quantitySelector.value = totalBoxes;
        }
      } else if (inputValue > this.minQuantity) {
        const totalBoxes = Math.ceil(inputValue / this.maxSize);
        this.totalBoxesInput.value = totalBoxes;
        if (this.quantitySelector) {
          this.quantitySelector.value = totalBoxes;
        }
      } else {
        this.totalBoxesInput.value = '';
        if (this.quantitySelector) {
          this.quantitySelector.value = Math.ceil(this.minQuantity/this.maxSize);
        }
      }
    }
  }

  customElements.define('pdp-calculator', PdpCalculator);
}
